var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterdOkasBoxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14.035,
    viewBox: "0 0 17 14.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9969",
    "data-name": "Group 9969",
    transform: "translate(18786 2453.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7130",
    "data-name": "Path 7130",
    className: "cls-1",
    d: "M64.538,48.907a.5.5,0,1,0,.354.146A.5.5,0,0,0,64.538,48.907Z",
    transform: "translate(-18836.652 -2493.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7133",
    "data-name": "Path 7133",
    className: "cls-1",
    d: "M64.538,48.907a.5.5,0,1,0,.354.146A.5.5,0,0,0,64.538,48.907Z",
    transform: "translate(-18839.652 -2493.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7134",
    "data-name": "Path 7134",
    className: "cls-1",
    d: "M64.538,48.907a.5.5,0,1,0,.354.146A.5.5,0,0,0,64.538,48.907Z",
    transform: "translate(-18842.652 -2493.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7135",
    "data-name": "Path 7135",
    className: "cls-2",
    d: "M-21048.227-23996.766v1.07",
    transform: "translate(2266.885 21551.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    className: "cls-2",
    d: "M-21048.227-23996.766v1.07",
    transform: "translate(2264.885 21551.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    className: "cls-1",
    d: "M-22637-21402.371l2.57-4.9h10.174l2.57,4.9",
    transform: "translate(3851.843 18954.268)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1826",
    "data-name": "Ellipse 1826",
    className: "cls-3",
    cx: 1.257,
    cy: 1.257,
    r: 1.257,
    transform: "translate(-18778.758 -2441.981)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9933",
    "data-name": "Group 9933",
    transform: "translate(-18785.5 -2448.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    className: "cls-1",
    d: "M10.381,7.347h5.162A.474.474,0,0,0,16,6.857V.49A.474.474,0,0,0,15.543,0H.457A.474.474,0,0,0,0,.49V6.857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    className: "cls-1",
    d: "M5.619,7.347H.457A.474.474,0,0,1,0,6.857V.49A.474.474,0,0,1,.457,0H15.543A.474.474,0,0,1,16,.49V6.857"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterdOkasBoxWhite);
export default __webpack_public_path__ + "static/media/RegisterdOkasBoxWhite.64690c2b91d9b22933e02b15c125eedc.svg";
export { ForwardRef as ReactComponent };